// import { getColor } from '@mui/material/styles';

// import breakpoints from 'utils/breakpoints';
import { getColor } from 'utils/colors';
import { remCalc } from 'utils/remCalc';

// const theme = createTheme({
// 	breakpoints: breakpoints,
// });

export const overrides = {
	'#event-form': {
		marginBottom: remCalc(64),
		'.MuiFormHelperText-root': {
			fontSize: remCalc(16),
			margin: 0,
		},

		'hr': {
			margin: remCalc('32, 0'),
		},

		'.MuiInputBase-input': {
			'&:-webkit-autofill, &:autofill': {
				'WebkitBoxShadow': `0 0 0 100px ${getColor('ivory', 400)} inset`,
				'WebkitTextFillColor': getColor('ivory', 800),
				'CaretColor': getColor('ivory', 800),
			},
		},
		'.MuiInputBase-root': {
			borderRadius: 0,

		},

		'textarea.MuiInputBase-input': {
			boxShadow: 'none',
			border: 'none',
		},

		'.MuiTextField-root': {
			margin: '10px 0',
		},

		'.submit-event-button': {
			marginTop: '1rem',
		},

		'.MuiAlert-root': {
			marginBottom: '1rem',
		},

		'.widget-selection-area': {
			'input': {
				margin: 0,
			}
		},

		'.button.space-right': {
			marginRight: '1rem',
		},

		'.location-details': {
			marginBottom: '1rem',
		},

		'.upload_fieldset': {
			textTransform: 'none',
			flexDirection: 'column',
			alignItems: 'flex-start',
			padding: remCalc('16, 0'),
			'.upload_input_wrapper': {
				display: 'flex',
				flexDirection: 'row',
				gap: remCalc(16),
				'.upload_input': {
					border: 'solid 1px ' + getColor('ivory', 700),
					padding: remCalc(16),
					marginTop: remCalc(10),
				},
			},
		},

		'.MuiButton-text': {
			flexWrap: 'wrap',
			'input, strong': {
				flex: 1,
			},
			'div.labeltext': {
				width: '100%',
			},
			'strong': {
				fontSize: '.75rem',
				textTransform: 'none',
				display: 'block',
				paddingLeft: '1rem',
			}
		}
	}
};

const styles = {};

export default styles;